export default "__VITE_ASSET__CvE7ZS4E__"